passwordValidator.$inject = [];

export function passwordValidator() {
    var directive = {
        bindToController: {
            password: '='
        },
        controller: PasswordValidatorController,
        controllerAs: 'vm',
        restrict: 'E',
        scope: {},
        templateUrl: 'app/components/password-validator.directive.html'
    };
    return directive;
}

class PasswordValidatorController {
    // TODO - Use <input-password/> instead
}

PasswordValidatorController.$inject = [];
